<template>
  <div>
    <div class="tab-content" id="myTabContent">
      <div class="tab-pane fade show active" tabindex="0">
        <div class="card mb-25 border-0 rounded-0  to-do-list-box letter-spacing">
          <div
            class="card-head  d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30">
            <h5 class="card-title fw-bold mb-0">声音提醒
              <span class="fs-12 text-muted fw-normal ms-5">
                有新的即时比赛，电脑通过声音提醒.<span class="text-danger">(部分电脑因系统设置无法自动播放声音)</span>
              </span>

            </h5>
            <span>
              <div>
                <b-form-checkbox checked="true" v-model="switchVoice" class="custom-control-primary" name="check-button"
                  switch @change="changeSwitchVoice">
                  <span class="switch-icon-left">
                    <feather-icon icon="BellIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="BellOffIcon" />
                  </span>
                </b-form-checkbox>
              </div>
              <!-- <el-switch v-model="switchVoice" @change="changeSwitchVoice" /> -->
            </span>

          </div>
          <div
            class="card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30">
            <ul class="to-do-list ps-0 list-unstyled mb-0">
              <li class="to-do-list-item d-flex align-items-center justify-content-between">
                <div class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium">
                  <input class="form-check-input shadow-none" v-model="voiceFlag" @change="changeVoice" type="radio"
                    name="flexRadioDefault" id="flexRadioDefault1" value="voice1" checked>
                  <label class="form-check-label">
                    <audio ref="audioPlayer">
                      <source src="@/assets/audio/ALAR.mp3" type="audio/mpeg">
                    </audio>
                    声音 ALAR
                  </label>
                </div>
                <div>
                  <feather-icon icon="PlayCircleIcon" size="20" class="text-primary me-20" @click="playSound1()" />
                </div>
              </li>
              <li class="to-do-list-item d-flex align-items-center justify-content-between">
                <div class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium">
                  <input class="form-check-input shadow-none" type="radio" v-model="voiceFlag" name="flexRadioDefault"
                    id="flexRadioDefault2" value="voice2" @change="changeVoice">
                  <label class="form-check-label">
                    <audio ref="audioPlayer3">
                      <source src="@/assets/audio/ALARM10.mp3" type="audio/mpeg">
                    </audio>
                    声音ALARM10
                  </label>
                </div>
                <feather-icon icon="PlayCircleIcon" size="20" class="text-primary me-20" @click="playSound3()" />
              </li>
              <li class="to-do-list-item d-flex align-items-center justify-content-between">
                <div class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium">
                  <input class="form-check-input shadow-none" type="radio" v-model="voiceFlag" name="flexRadioDefault"
                    id="flexRadioDefault2" value="voice3" @change="changeVoice">
                  <label class="form-check-label">
                    <audio ref="audioPlayer4">
                      <source src="@/assets/audio/ALARM11.mp3" type="audio/mpeg">
                    </audio>
                    声音ALARM11
                  </label>
                </div>
                <feather-icon icon="PlayCircleIcon" size="20" class="text-primary me-20" @click="playSound4()" />
              </li>
              <li class="to-do-list-item d-flex align-items-center justify-content-between">
                <div class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium">
                  <input class="form-check-input shadow-none" type="radio" v-model="voiceFlag" name="flexRadioDefault"
                    id="flexRadioDefault2" value="voice4" @change="changeVoice">
                  <label class="form-check-label">
                    <audio ref="audioPlayer2">
                      <source src="@/assets/audio/ALARM8.mp3" type="audio/mpeg">
                    </audio>
                    声音ALARM8
                  </label>
                </div>
                <!-- <i class="PlayCircleIcon text-primary" @click="playSound2()"></i> -->
                <feather-icon icon="PlayCircleIcon" size="20" class="text-primary me-20" @click="playSound2()" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>


    <div class="tab-content" id="myTabContent">
      <div class="tab-pane fade show active" id="tasks-tab-pane" role="tabpanel" tabindex="0">
        <div class="card mb-25 border-0 rounded-0  to-do-list-box letter-spacing">
          <div
            class="card-head  d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30">

            <h5 class="card-title fw-bold mb-0">
              <feather-icon icon="BookmarkIcon" size="20" class="text-warning" />消息推送
              <span class="fs-12 text-muted fw-normal ms-5">
                有新的即时比赛，通过邮箱发送提醒.
              </span>
            </h5>
            <span>
              <b-form-checkbox checked="true" class="custom-control-primary" name="check-button" v-model="switchMessage"
                switch @change="onchangeSwitchMessage">
                <span class="switch-icon-left">
                  <feather-icon icon="check-button" />
                </span>
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
              </b-form-checkbox>

            </span>

          </div>
          <div
            class="card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30">
            <ul class="to-do-list ps-0 list-unstyled mb-0">
              <li class="to-do-list-item d-sm-flex align-items-center justify-content-between">
                <div class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium">
                  <input class="form-check-input shadow-none" type="checkbox" v-model="checkMessage1" id="message1"
                    @change="onCheckedValueChange" />
                  <label class="form-check-label">
                    走地大小球
                  </label>
                </div>

              </li>
              <li class="to-do-list-item d-sm-flex align-items-center justify-content-between">
                <div class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium">
                  <input class="form-check-input shadow-none" type="checkbox" v-model="checkMessage2" id="message2"
                    @change="onCheckedValueChange" />
                  <label class="form-check-label">
                    走地让球
                  </label>
                </div>

              </li>
              <li class="to-do-list-item d-sm-flex align-items-center justify-content-between">
                <div class="form-check form-check-primary mb-0 fs-md-15 fs-lg-16 text-black fw-medium">
                  <input class="form-check-input shadow-none" type="checkbox" v-model="checkMessage3" id="message2"
                    @change="onCheckedValueChange" />
                  <label class="form-check-label">
                    走地角球
                  </label>
                </div>

              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request.js';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'


export default {
  name: "Setting",

  props: {
    userInfo: {
      type: Object, // 指定props的类型为Array  
      default: () => { } // 提供一个默认值，以防父组件没有传递该prop  
    }
  },

  watch: {
    //正确给 cData 赋值的 方法
    userInfo: function (newVal, oldVal) {
      this.userData = newVal;  //newVal即是chartData
      newVal && this.randerView(); //newVal存在的话执行drawChar函数
    }
  },

  data() {
    return {
      switchVoice: '',
      switchMessage: '',
      voiceFlag: '',    // 选中声音 
      checkMessage1: '', // 多选消息类型
      checkMessage2: '', // 多选消息类型
      checkMessage3: '', // 多选消息类型
      userData: ''
    };
  },

  mounted() {
    this.showToast('success', 'top', '', '修改成功');
  },

  methods: {
    playSound1() {
      const audioPlayer = this.$refs.audioPlayer;
      audioPlayer.play();
    },
    playSound2() {
      const audioPlayer = this.$refs.audioPlayer2;
      audioPlayer.play();
    },
    playSound3() {
      const audioPlayer = this.$refs.audioPlayer3;
      audioPlayer.play();
    },
    playSound4() {
      const audioPlayer = this.$refs.audioPlayer4;
      audioPlayer.play();
    },

    randerView() {
      // 消息推送开关
      this.switchMessage = this.userData.tskg == '1';
      if (this.userData.txlx.includes('02')) {
        this.checkMessage1 = true;
      }
      if (this.userData.txlx.includes('03')) {
        this.checkMessage2 = true;
      }
      if (this.userData.txlx.includes('05')) {
        this.checkMessage3 = true;
      }

      // 声音开关
      this.switchVoice = localStorage.getItem('soccer_switchVoice');
      console.log(this.switchVoice);
      this.switchVoice = this.switchVoice == 'true'
      this.voiceFlag = localStorage.getItem('soccer_voiceFlag');
    },
    // 切换声音开关
    changeSwitchVoice() {
      localStorage.setItem('soccer_switchVoice', this.switchVoice);
    },
    onchangeSwitchMessage() {
      if (this.switchMessage && !this.checkMessage1 && !this.checkMessage2 && !this.checkMessage3) {
        this.checkMessage1 = true;
      }
      if (!this.switchMessage) {
        this.checkMessage1 = false;
        this.checkMessage2 = false;
        this.checkMessage3 = false;
      }

      this.postData();
    },
    // 选择声音
    changeVoice() {
      if (this.voiceFlag) {
        this.switchVoice = true;
      }
      if (this.voiceFlag == 'voice1') {
        this.playSound1();
      }
      if (this.voiceFlag == 'voice2') {
        this.playSound4();
      }
      if (this.voiceFlag == 'voice3') {
        this.playSound3();
      }
      if (this.voiceFlag == 'voice4') {
        this.playSound2();
      }
      localStorage.setItem('soccer_voiceFlag', this.voiceFlag);
      localStorage.setItem('soccer_switchVoice', this.switchVoice);
    },
    // 选择推送开关
    onCheckedValueChange() {
      if (this.checkMessage1 || this.checkMessage2 || this.checkMessage3) {
        this.switchMessage = true;
      }
      if (!this.checkMessage1 && !this.checkMessage2 && !this.checkMessage3) {
        this.switchMessage = false;
      }
      if (!this.switchMessage) {
        this.checkMessage1 = false;
        this.checkMessage2 = false;
        this.checkMessage3 = false;
      }
      this.postData();

    },
    postData() {
      var tskg = this.switchMessage ? 1 : 0;
      var txlxList = [];
      if (this.checkMessage1) {
        txlxList.push("02");
      }
      if (this.checkMessage2) {
        txlxList.push("03");
      }
      if (this.checkMessage3) {
        txlxList.push("05");
      }
      let txlx = txlxList.length > 0 ? txlxList.join(',') : '';
      var post_url = 'football/admin/william/interfaceAction!updateUserInfo.action';
      post_url += "?tskg=" + tskg + "&txlx=" + txlx + "&email=" + this.userInfo.email;
      let opts = {
        type: 1, //1为数据接口；2为静态资源请求
        url: post_url,
        method: 'get'
      };
      this.loading = true;
      request.httpRequest(opts).then(response => {
        this.loading = false;
        if (response == null) {
          this.showToast('danger', 'top', '', '网络错误');
          return;
        }
        if (response.status == 200) {
          this.showToast('success', 'top', '', '修改成功');
          return;
        }
      });
    },
    showToast(variant, position, title, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title == '消息' ? '' : title,
          icon: 'InfoIcon',
          text: text,
          variant,
        },
      },
        {
          position,
        })
    }
  }
}
</script>
<style lang="css" scoped>
[dir] .to-do-list-box .to-do-list .to-do-list-item {
  border-top: 1px dashed #d9e9ef;
  padding-top: 17.1px;
  padding-bottom: 8px;
}
</style>